import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const ITEMS = [
  {
    q: 'Is it free?',
    a: 'Yes, free during our public beta. We may introduce paid tiers later for power users; the core safety features will always have a free option.',
  },
  {
    q: 'Where do the interaction warnings come from?',
    a: 'Two sources: official FDA drug-label text via openFDA, and reasoning by an Anthropic Claude language model. Every result cites its sources.',
  },
  {
    q: 'Will my data stay private?',
    a: 'Yes. Your medications and history stay in your account. We never sell or share data. You can export or delete your account at any time.',
  },
  {
    q: 'Does this replace my doctor?',
    a: 'No. Heritage Compass is a thinking aid. Always confirm changes with a qualified healthcare professional.',
  },
  {
    q: 'Does it work without prescriptions in a pharmacy system?',
    a: 'Yes \u2014 Heritage Compass works with whatever you tell it about. It does not connect to pharmacy systems (yet).',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section id="faq" className="py-16 md:py-20 scroll-mt-20" style={{ backgroundColor: '#FBF6EF' }} data-testid="landing-faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12" style={{ color: '#5B2D1F' }}>
          Frequently asked questions
        </h2>

        <div className="space-y-3">
          {ITEMS.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className="rounded-2xl border overflow-hidden"
                style={{ backgroundColor: '#FFFFFF', borderColor: '#D7E2E8' }}
                data-testid={`landing-faq-${i}`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-3 px-6 py-4 text-left min-h-[52px]"
                  aria-expanded={isOpen}
                  data-testid={`landing-faq-${i}-toggle`}
                >
                  <span className="text-base font-bold" style={{ color: '#5B2D1F' }}>{item.q}</span>
                  <ChevronDown
                    className="h-5 w-5 shrink-0 transition-transform duration-200"
                    style={{ color: '#D77A52', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-5">
                    <p className="text-sm leading-relaxed" style={{ color: '#6B4A3A' }}>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
